import {
    GetSubmitRequestQuoteApiParameter,
    SubmitRequestQuoteModel,
    getSubmitRequestQuote,QuoteProductsList
} from "@NA/Services/ADISubmitRequestQuote";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import {
    HasOnComplete,
    HasOnSuccess,
    createHandlerChainRunnerOptionalParameter,
} from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<
    GetSubmitRequestQuoteApiParameter & HasOnSuccess & HasOnComplete,
    SubmitRequestQuoteModel
>;

export const LoadSubmitRequestQuote: HandlerType = async (props: any) => {
    props.apiResult = await getSubmitRequestQuote(props.parameter);
};

export const DispatchCompleteSubmitRequestQuote: HandlerType = props => {
    props.parameter && props.parameter.onComplete && props.parameter?.onComplete(props.apiResult);
};

export const chain = [LoadSubmitRequestQuote, DispatchCompleteSubmitRequestQuote];

const getSubmitRequestQuotenHandler = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        contactName: "",
        email: "",
        phoneNumber: "",
        projectName: "",
        quoteProductsList:[] as QuoteProductsList[] , // This reference is being used by P21
        notes: "",
        dcEmail: "",
        // fileCollection: [], code from Spire Prod
        companyName: "",
        customerNumber: "",
        // Below properties are being used in P21
        sourceLocationID: "",
        salesLocation: "",
        onComplete: (onSubmitDataResponse: any): void => {},
        
    },
    "getSubmitRequestQuotenHandler",
);
export default getSubmitRequestQuotenHandler;
